import type { PartnerName } from '../../../../definitions';
import type { PriceOfferQuoteQueryParams } from '../../queries';

export interface BrandPriceComparisonProps extends PriceOfferQuoteQueryParams {
  readonly partnerName: PartnerName | null;
}

export enum Error {
  CreatePriceOffer = 'createPriceOffer',
  PartnerNotSupported = 'Partner Not Supported',
}
